import { type config } from '@air/api';

import { configureAPIPackage } from './configureAPIPackage';

export const restoreAPIPackageConfiguration = (savedAPIConfig: ReturnType<typeof config.getAuthConfiguration>) => {
  configureAPIPackage({
    cognitoConfigParams: {
      authenticationFlowType: savedAPIConfig.authenticationFlowType,
      mandatorySignIn: savedAPIConfig.mandatorySignIn,
      region: savedAPIConfig.region,
      userPoolId: savedAPIConfig.userPoolId,
    },
    oauthConfigParams: savedAPIConfig.oauth,
  });
};
